import { Pipe, PipeTransform } from '@angular/core';
import {
  PublicationStatus,
  ShiftDispositionAssignable,
  ShiftDispositionAssignableShift,
} from '@wilson/interfaces';

@Pipe({
  name: 'notPublishedShifts',
  standalone: false,
})
export class NotPublishedShiftsPipe implements PipeTransform {
  transform(
    oneOrMoreShiftAssignables:
      | ShiftDispositionAssignable[]
      | ShiftDispositionAssignable
      | ShiftDispositionAssignableShift,
  ) {
    const shiftAssignables = Array.isArray(oneOrMoreShiftAssignables)
      ? oneOrMoreShiftAssignables
      : [oneOrMoreShiftAssignables];

    return shiftAssignables.filter(
      (shift) =>
        (shift?.record as any)['publicationStatus'] ===
          PublicationStatus.NotPublished ||
        (shift?.record as any)['publicationStatus'] ===
          PublicationStatus.NotPublishedAgain,
    );
  }
}
